import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.find";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import "core-js/modules/es6.function.name";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.fill";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// @ts-check
import { getIndexedCollection } from '@/common/helpers';
/**
 * @param {{work_type_id: number}[]} rawWorkTypes
 * @param {Record<number, import('@/store/store').WorkTypeShort>} workTypesById
 * @returns {import('@/store/store').WorkTypeLabel[]}
 */

export function formWorkTypes(rawWorkTypes, workTypesById) {
  if (!rawWorkTypes || !workTypesById) {
    return [];
  }

  return rawWorkTypes.map(function (workType) {
    return {
      id: workType.work_type_id,
      label: workTypesById[workType.work_type_id] ? workTypesById[workType.work_type_id].label : ''
    };
  });
}
/**
 * @param {import('@/store/store').CurrentWorkTypes[]} currentWorkTypes
 * @param {import('@/store/store').WorkTypeShort[]} workTypesArr
 * @returns {Record<number, import('@/store/store').WorkTypeProcessed>}
 */

export function formWorkTypesById(currentWorkTypes, workTypesArr) {
  if (!currentWorkTypes || !workTypesArr) {
    return {};
  }

  var currentWorkTypesIndexed = getIndexedCollection(currentWorkTypes, 'work_type_id');
  return workTypesArr.reduce(function (acc, workType) {
    var found = currentWorkTypesIndexed[workType.id];
    acc[workType.id] = _objectSpread(_objectSpread({}, workType), {}, {
      state: found ? found.priority : null,
      absId: found ? found.id : null
    });
    return acc;
  }, {});
}
/**
 * @param {import('@/store/store').Department} department
 * @returns {import('@/store/store').OpenCloseTimeDictionary}
 */

export function formOpenCloseTimes(department) {
  /** @type {import('@/store/store').OpenCloseTimeDictionary} */
  var openCloseTimes = {};

  if (!department || !department.tm_open_dict || !department.tm_close_dict) {
    return openCloseTimes;
  }

  if (department.tm_open_dict.all) {
    var weekNumber = new Array(7).fill(0);
    weekNumber.forEach(function (_, week) {
      openCloseTimes[week] = {
        start: department.tm_open_dict.all,
        end: department.tm_close_dict.all
      };
    });
  } else {
    Object.keys(department.tm_open_dict).forEach(function (week) {
      openCloseTimes[week] = {
        start: department.tm_open_dict[week],
        end: department.tm_close_dict[week]
      };
    });
  }

  return openCloseTimes;
}
/**
 * Forms an employment object
 * @param {object} options
 * @param {import('@/store/store').RawEmployment} options.employment
 * @param {Record<number, import('@/store/store').Department>} options.depsById
 * @param {Record<number, import('@/store/store').WorkTypeShort>} options.workTypesById
 * @param {import('@/store/store').WorkTypeShort[]} options.workTypes
 * @param {import('@/store/store').EmploymentPosition[]} options.positions
 * @returns {import('@/store/store').StoreEmployment}
 */

export function formEmployment(_ref) {
  var _positions$find;

  var employment = _ref.employment,
      _ref$depsById = _ref.depsById,
      depsById = _ref$depsById === void 0 ? {} : _ref$depsById,
      workTypesById = _ref.workTypesById,
      _ref$positions = _ref.positions,
      positions = _ref$positions === void 0 ? [] : _ref$positions,
      workTypes = _ref.workTypes;

  if (!employment || _typeof(employment) !== 'object') {
    throw new Error('formEmployment error: employment not provided or incorrect');
  }

  var worker_constraints = employment.worker_constraints,
      user = employment.user,
      dataToStay = _objectWithoutProperties(employment, ["worker_constraints", "user"]);

  var department = depsById[employment.shop_id];

  var output = _objectSpread(_objectSpread({}, dataToStay), {}, {
    _dep_title: department ? department.name || '' : '',
    _work_type_ids: employment.work_types.map(function (wt) {
      return wt.work_type_id;
    }),
    _work_types: formWorkTypes(employment.work_types, workTypesById),
    _week_availability: employment.week_availability === 7 ? 'd7' : 'd0',
    _work_types_by_id: formWorkTypesById(employment.work_types, workTypes),
    _worker_constraints: _toConsumableArray(worker_constraints),
    _position_title: employment.position_id ? ((_positions$find = positions.find(function (position) {
      return position.id === employment.position_id;
    })) === null || _positions$find === void 0 ? void 0 : _positions$find.name) || '' : '',
    _expansion_label: department ? department.name || '' : '',
    _dep_start_time: department ? department.tm_shop_opens || '' : '',
    _dep_end_time: department ? department.tm_shop_closes || '' : '',
    _dep_time_gap: department ? department.forecast_step_minutes || '' : '',
    _open_close_tms: formOpenCloseTimes(department)
  });

  return output;
}
/**
 * @param {any[]} rawData
 * @param {any[]} workTypeNames
 * @returns {import('@/store/store').WorkTypeShort[]}
 */

export function formWorkTypesFromRequest(rawData, workTypeNames) {
  if (!Array.isArray(rawData)) {
    return [];
  }

  return rawData.sort(function (a, b) {
    return b.priority - a.priority;
  }).map(function (el) {
    var _workTypeNames$el$wor;

    return {
      id: el.id,
      label: (_workTypeNames$el$wor = workTypeNames[el.work_type_name_id]) === null || _workTypeNames$el$wor === void 0 ? void 0 : _workTypeNames$el$wor.name,
      nameId: el.work_type_name_id,
      shopId: el.shop_id
    };
  });
}
/**
 * @param {object} options
 * @param {import('@/store/store').StoreEmployment} options.employment
 * @param {import('@/store/store').Department[]} options.departmentsArray
 * @param {Record<number, import('@/store/store').StoreNetwork>} options.networksIndexed
 * @returns {boolean}
 */

export function canEditEmployment(_ref2) {
  var employment = _ref2.employment,
      departmentsArray = _ref2.departmentsArray,
      networksIndexed = _ref2.networksIndexed;
  var dt_fired = employment.dt_fired,
      dt_hired = employment.dt_hired;
  var isInFuture = +new Date(dt_hired) > Date.now();
  var isActualEmployment = +new Date(dt_fired) > Date.now();
  var codeCheck = true;
  var employmentsDepartment = departmentsArray.find(function (el) {
    return +el.id === +employment.shop_id;
  });

  if (!employmentsDepartment) {
    return !dt_fired || isActualEmployment || isInFuture;
  }

  if (employmentsDepartment) {
    var network = networksIndexed[employmentsDepartment.network_id];

    if (network && network.forbid_edit_employments_came_through_integration) {
      codeCheck = !employment.code;
    }
  }

  return (!dt_fired || isActualEmployment || isInFuture) && codeCheck;
}